import { formatArray,formatRules,formatDatas } from "@/utils/util";
export default {
    namespaced: true,
    state: {
        config: {
          userInputForm:[]
        }, // 配置信息
        form_data: null, // 表单数据
        stragy_data: null,// 策略数据
    },
    getters: {
      userForm: state => {
        let { userInputForm } = state.config
        
        let user_form = userInputForm ? formatArray(userInputForm).filter(item => !item.hide) : []

        return {
            form:user_form ? user_form : [],
            rules:userInputForm ? formatRules(userInputForm) : [],
            formParmas:userInputForm ? formatDatas(userInputForm) : [],
            defaultFormData:{
              ...state.form_data,
              ...state.stragy_data
            }
        };
      },
      isFile: state => {
        let { userInputForm } = state.config
        let user_form = userInputForm ? formatArray(userInputForm).filter(item => !item.hide) : []
        return user_form.some(item => item.type == 'file')
      },
        isAudio: state => {
          let { speechToText } =  state.config
            if(speechToText && speechToText.enabled){
                return speechToText.enabled
            }else{
                return false
            }
        },
      isSubmit: state => {
        let { userInputForm } = state.config
        let { form_data,stragy_data } = state

        let defaultFormData = {
          ...form_data,
          ...stragy_data

        }
        let user_form = userInputForm ? formatArray(userInputForm).filter(item => !item.hide) : []
        
        let required_true = user_form.filter(item => item.required)
        if(required_true.length == 0){
          return true
        }

        let required = user_form.filter(item => item.required && !defaultFormData[item.variable])
        
        return required.length == 0
        
      },
    },
    mutations: {
      setStragyData: (state, payload) => {
        state.stragy_data = payload;
      },
      setConfig: (state, payload) => {
        
        state.form_data = null
        state.config = payload;
      },
      setFormData: (state, payload) => {
        state.form_data = payload;
      }
    },
  };
  